import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";

export function DashboardStoreOptionSelector({ onSelect }) {
  const [selectedOption, setSelectedOption] = useState({
    inventarios: true,
    compras: false,
    ventas: false,
    traspasos: false,
    ajustes: false,
    tipologias: false,
  });

  function handleActiveOption(key) {
    setSelectedOption((prev) =>
      Object.keys(prev).reduce((acc, curr) => {
        acc[curr] = curr === key;
        return acc;
      }, {}),
    );
  }

  useEffect(() => {
    onSelect(selectedOption);
  }, [selectedOption]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
      }}
    >
      <ButtonIconH
        text="Inventarios"
        selected={selectedOption.inventarios}
        onClick={() => {
          handleActiveOption("inventarios");
        }}
      ></ButtonIconH>
      <ButtonIconH
        text="Compras"
        selected={selectedOption.compras}
        onClick={() => {
          handleActiveOption("compras");
        }}
      ></ButtonIconH>
      <ButtonIconH
        text="Ventas y devoluciones"
        selected={selectedOption.ventas}
        onClick={() => {
          handleActiveOption("ventas");
        }}
      ></ButtonIconH>
      <ButtonIconH
        text="Traspasos"
        selected={selectedOption.traspasos}
        onClick={() => {
          handleActiveOption("traspasos");
        }}
      ></ButtonIconH>
      <ButtonIconH
        text="Ajustes"
        selected={selectedOption.ajustes}
        onClick={() => {
          handleActiveOption("ajustes");
        }}
      ></ButtonIconH>
      <ButtonIconH
        text="Tipologías"
        selected={selectedOption.tipologias}
        onClick={() => {
          handleActiveOption("tipologias");
        }}
      ></ButtonIconH>
    </div>
  );
}
